import React, { Suspense } from 'react'

import { type ColumnConfig } from '@ant-design/plots'
import { Card, Spin } from 'antd'
import { useUnit } from 'effector-react'

import { COMMON_CHARTS_CONFIG } from '../../lib/constants'
import { $radioLaunches } from '../../model/statistics-app-data.model'
import styles from './styles.module.scss'

const Column = React.lazy(
  () => import('@ant-design/plots/es/components/column'),
)

export const RadioLaunchesChart = () => {
  const data = useUnit($radioLaunches)
  const config: ColumnConfig = {
    data,
    style: {
      radiusTopLeft: 6,
      radiusTopRight: 6,
      radiusBottomLeft: 6,
      radiusBottomRight: 6,
    },
    axis: {
      x: {
        labelStroke: 'rgba(0,0,0,0.45)',
        labelFontWeight: 300,
        labelFontSize: 12,
        grid: false,
      },
      y: {
        labelStroke: 'rgba(0,0,0,0.45)',
        labelFontWeight: 300,
        labelFontSize: 12,
        grid: true,
        gridStroke: 'rgba(0,0,0,1)',
        gridOpacity: 0.8,
        gridLineDash: [0, 0],
        gridLineWidth: 1,
      },
    },
    colorField: 'data',
    scale: {
      color: {
        range: ['#7F45E5'],
      },
    },
    ...COMMON_CHARTS_CONFIG,
  }

  return (
    <Card className={styles.statisticsCard}>
      <Suspense fallback={<Spin />}>
        <Column {...config} />
      </Suspense>
    </Card>
  )
}
